import React, {useState} from 'react';
import 'contents/assets/scss/page/data.scss';
import Paging from '../../component/Inc/Paging';
import Upload from '../../component/Inc/Upload';
import Tab from '../../component/Inc/Tab';
import PopManageCategory from './_PopManageCategory';
import BtnLike from "../../component/Inc/BtnLike";//좋아요 버튼
function ExpectingExam() {
  const [modalManageCategory, setModalManageCategory] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '국어', value: 0},
    {title: '영어', value: 1},
    {title: '수학', value: 2},
    {title: '과탐', value: 3},
    {title: '사탐', value: 4},
    {title: '수시', value: 5}
  ];
  return (
    <main className="com_container p_expecting_exam">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu4_5">수업 연구 자료</h2>
          <div className="com_btn_wrap">
            <button
              onClick={() => {
                setModalManageCategory(true);
              }}
              className="com_btn orange s btn_plus"
            >
              카테고리 관리
            </button>
            <button className="com_btn orange s btn_plus">문제 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top type_column">
              <div className="com_input_wrap">
                <select className="select xs">
                  <option value="출처 선택">출처 선택</option>
                </select>
                <select className="select xs">
                  <option value="구분2 (연도)">구분2 (연도)</option>
                </select>
                <select className="select xs">
                  <option value="구분3">구분3</option>
                </select>
                <select className="select xs">
                  <option value="구분4">구분4</option>
                </select>
                <select className="select xs">
                  <option value="구분5">구분5</option>
                </select>
                <select className="select xs">
                  <option value="구분6">구분6</option>
                </select>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <section className="com_board_search end">
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                </div>
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="auto" />
                <col width="23%" />
                <col width="23%" />
                <col width="23%" />
                <col width="23%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>영역</th>
                  <th>파일</th>
                  <th>다운</th>
                </tr>
              </thead>
              <tbody>
                <tr className="selected">
                  <td>
                    <BtnLike/>
                  </td>
                  <td className="td_left">2022.08.25</td>
                  <td>국어</td>
                  <td>
                    <button className="btn_link blue">다운로드</button>
                  </td>
                  <td>123</td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{10 - idx}</td>
                      <td className="td_left">2022.08.25</td>
                      <td>국어</td>
                      <td>
                        <button className="btn_link blue">다운로드</button>
                      </td>
                      <td>123</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <div className="count">
                <p>
                  댓글 <span className="cnt">10</span>
                </p>
                <span className="dot" />
                <p>
                  조회 <span className="cnt">321</span>
                </p>
              </div>
            </div>
            <div className="com_input_wrap">
              <div className="sec_input select_box">
                <div className="com_btn_wrap">
                  <BtnLike/>
                  <button className="btn_edit"></button>
                  <button className="btn_delete"></button>
                </div>
              </div>
              <div className="com_board_box">
                <div className="board_item">
                  <div className="info center">
                    <div className="tit">영역 선택</div>
                    <div className="cont">
                      <div className="com_input_wrap">
                        <select className="select xs">
                          <option value="선택">선택</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="info center">
                    <div className="tit">구분1 선택</div>
                    <div className="cont">
                      <div className="com_input_wrap">
                        <select className="select xs">
                          <option value="선택">선택</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="info center">
                    <div className="tit">구분2 선택</div>
                    <div className="cont">
                      <div className="com_input_wrap">
                        <select className="select xs">
                          <option value="선택">선택</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="info center">
                    <div className="tit">구분3 선택</div>
                    <div className="cont">
                      <div className="com_input_wrap">
                        <select className="select xs">
                          <option value="선택">선택</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="info center">
                    <div className="tit">구분4 선택</div>
                    <div className="cont">
                      <div className="com_input_wrap flex_row">
                        <select className="select xs">
                          <option value="직접 입력">직접 입력</option>
                        </select>
                        <select className="select xs">
                          <option value="선택">선택</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="info center">
                    <div className="tit">구분5 선택</div>
                    <div className="cont">
                      <div className="com_input_wrap flex_row">
                        <select className="select xs">
                          <option value="직접 입력">직접 입력</option>
                        </select>
                        <select className="select xs">
                          <option value="선택">선택</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="info center">
                    <div className="tit">구분6 선택</div>
                    <div className="cont">
                      <div className="com_input_wrap flex_row">
                        <select className="select xs">
                          <option value="직접 입력">직접 입력</option>
                        </select>
                        <select className="select xs">
                          <option value="선택">선택</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="com_input_upload">
                <Upload title="파일 등록" className="com_btn gray s wl" />
                <p className="file">
                  <span className="txt">File name.pdf</span>
                  <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  <button type="button" className="btn_down" onClick={() => {}}></button>
                </p>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange s">등록</button>
            </div>
            <div className="com_board_box">
              <div className="detail_tit_sub">
                <p className="name">다운로드 정보</p>
              </div>
              <div className="board_item download_wrap">
                <div className="down_list">
                  {[...Array(40)].map((i, idx) => (
                    <div className="info" key={i}>
                      <span className="cont">
                        <button className="btn_link">김담임102 </button>
                        <span className="desc dot">2025, 05, 20 11 : 30</span>
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>
      <PopManageCategory open={modalManageCategory} close={() => setModalManageCategory(false)} />
    </main>
  );
}

export default ExpectingExam;
